import toast from "@/lib/toast";

export const handleFormErrors = (errors: any, setError: any) => {
  toast.dismiss();
  if (!errors || typeof errors !== "object") {
    toast.error("Something went wrong.");
    return;
  }

  const keys = Object.keys(errors);
  const fieldKeys = keys.filter((key) => key !== "message");

  if (fieldKeys.length === 0) {
    toast.error(errors.message || "Something went wrong.");
    return;
  }

  fieldKeys.forEach((key) => {
    const value = errors[key];
    const message = Array.isArray(value) ? value[0] : value;

    if (message) {
      setError(key, {
        type: "server",
        message,
      });
    }
  });
};
